module.exports = __webpack_public_path__ + "img/mission_map_3d_re.36afb97b.svg";